import { render, staticRenderFns } from "./BIMData.vue?vue&type=template&id=7c4db8da&scoped=true&"
import script from "./BIMData.vue?vue&type=script&lang=js&"
export * from "./BIMData.vue?vue&type=script&lang=js&"
import style0 from "./BIMData.vue?vue&type=style&index=0&id=7c4db8da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4db8da",
  null
  
)

export default component.exports